export function joinBase(base: string, path: string): string {
  const prefix = base.endsWith('/') ? base.slice(0, -1) : base
  const suffix = path.startsWith('/') ? path : `/${path}`
  return `${prefix}${suffix}`
}

export const BASE_URL: string = import.meta.env.BASE_URL

export const BASE_PATH: string = BASE_URL.endsWith('/') ? BASE_URL.slice(0, -1) : BASE_URL

export function appUrl(path: string): string {
  return joinBase(BASE_URL, path)
}
